import React, { Component } from "react";
import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";

const CssTextField = styled(TextField)({
  "& label": {
    color: "#fff",
  },
  "& label.Mui-focused": {
    color: "#fff",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "green",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#fff",
    },
    "&:hover fieldset": {
      borderColor: "#fff",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#fff",
    },
  },
});

class LoginForm extends Component {
  state = { mobile: "" };
  render() {
    const { handleChange, handleLogin, mobileNumber } = this.props;
    return (
      <Box sx={{ width: "100%" }}>
        <Stack
          sx={{ bottom: 70, right: 15, left: 15, position: "absolute" }}
          spacing={2}
        >
          <CssTextField
            label="شماره موبایل"
            type="tel"
            InputProps={{
              inputProps: {
                style: { textAlign: "center", color: "#fff" },
              },
            }}
            value={mobileNumber}
            onChange={(e) => handleChange(e, "mobile")}
          />

          <Button variant="contained" onClick={handleLogin}>
            ورود
          </Button>
        </Stack>
      </Box>
    );
  }
}

export default LoginForm;
